
import { Component, Mixins } from "vue-property-decorator";
import { default as ImageDrawableObjectMixin } from "./ImageDrawableObjectMixin.vue";
import { default as ClaioApplicationLaunchableMixin } from "./ClaioApplicationLaunchableMixin.vue";

@Component({
})
export default class ClaioContentDrawableObjectMixin extends Mixins(
  ImageDrawableObjectMixin,
  ClaioApplicationLaunchableMixin,
) {
}
